import { render, staticRenderFns } from "./reportes-comision-por-plaza.vue?vue&type=template&id=3c576c62&scoped=true&"
import script from "./reportes-comision-por-plaza.vue?vue&type=script&lang=js&"
export * from "./reportes-comision-por-plaza.vue?vue&type=script&lang=js&"
import style0 from "./reportes-comision-por-plaza.vue?vue&type=style&index=0&id=3c576c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c576c62",
  null
  
)

export default component.exports